export default {
    SenhaDeAcesso: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "senha-de-acesso"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/SenhaDeAcesso.js
// module id = mQkj
// module chunks = 32